import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import ApiConstants from 'src/app/shared/constants/api.constants';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/shared/services/common.service';
import {
  PaymentParams,
  PaymentsResponse,
  PaymentStatisticsResponse,
} from 'src/app/shared/model/payment.model';

@Injectable({
  providedIn: 'root',
})
export class PaymentsService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getPayments(paymentParams: PaymentParams): Observable<PaymentsResponse> {
    let API_URL = `${this.apiUrl}${ApiConstants.GET_PAYMENTS}?PageNumber=${paymentParams.pageNumber}&PageSize=${paymentParams.pageSize}`;

    if (paymentParams.sortField !== null && paymentParams.sortField !== undefined) {
      API_URL += CommonService.getQuerySingleParams('SortBy', paymentParams.sortField);
    }

    if (
      paymentParams.sortOrder !== null &&
      paymentParams.sortOrder !== undefined &&
      !paymentParams.invoiceStatus
    ) {
      API_URL += CommonService.getQuerySingleParams('SortOrder', paymentParams.sortOrder);
    }

    if (paymentParams.invoiceStatus) {
      API_URL += CommonService.getQuerySingleParams('invoiceStatus', paymentParams.invoiceStatus);
    }

    if (
      paymentParams.isExport !== null &&
      paymentParams.isExport !== false &&
      paymentParams.isExport !== undefined
    ) {
      API_URL += CommonService.getQuerySingleParams('isExport', paymentParams.isExport);
    }

    return this.http
      .get<PaymentsResponse>(API_URL)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }

  getPaymentStatistics(): Observable<PaymentStatisticsResponse> {
    const API_URL = `${this.apiUrl}${ApiConstants.PAYMENT_STATISTICS}`;
    return this.http
      .get<PaymentStatisticsResponse>(API_URL)
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => error)));
  }
}
